<template>
  <v-card outlined>
    <v-card-title>
      パーミッショングループ一覧
      <v-spacer />
      <v-btn
        color="primary"
        @click="$emit('create')"
      >
        <v-icon left>
          {{ icons.mdiPlus }}
        </v-icon>
        新規作成
      </v-btn>
    </v-card-title>

    <v-data-table
      :items="groups"
      :headers="headers"
      :header-props="{ sortByText: 'ソート' }"
      :footer-props="{ itemsPerPageText: '行/ページ:' }"
      no-data-text="パーミッショングループがありません"
    >
      <template #[`item.permissions`]="{ item }">
        <v-chip
          v-for="permission in item.permissions"
          :key="permission.id"
          small
          class="ma-1"
        >
          {{ getSubjectLabel(permission.subject) }} : {{ permission.action }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-btn
          icon
          color="primary"
          @click="$emit('edit', item)"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
        <v-btn
          icon
          color="error"
          @click="confirmDelete(item)"
        >
          <v-icon>{{ icons.mdiDelete }}</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      v-model="deleteDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title>グループの削除</v-card-title>
        <v-card-text>
          「{{ targetGroup ? targetGroup.name : '' }}」を削除しますか？
          このグループに割り当てられているユーザーからも権限が削除されます。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="error"
            :loading="isDeleting"
            @click="deleteGroup"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiPlus, mdiDelete, mdiPencil } from '@mdi/js'

export default {
  name: 'PermissionGroupList',
  props: {
    groups: {
      type: Array,
      required: true,
    },
    subjectLabels: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const deleteDialog = ref(false)
    const targetGroup = ref(null)
    const isDeleting = ref(false)

    const getSubjectLabel = subject => props.subjectLabels[subject] || subject

    const headers = [
      { text: 'グループ名', value: 'name', width: '180px' },
      { text: '権限', value: 'permissions', sortable: false },
      {
        text: '操作', value: 'actions', sortable: false, width: '120px',
      },
    ]

    const confirmDelete = group => {
      targetGroup.value = group
      deleteDialog.value = true
    }

    const deleteGroup = async () => {
      isDeleting.value = true
      emit('delete', targetGroup.value)
      deleteDialog.value = false
      isDeleting.value = false
    }

    return {
      headers,
      deleteDialog,
      targetGroup,
      isDeleting,
      confirmDelete,
      deleteGroup,
      getSubjectLabel,
      icons: { mdiPlus, mdiDelete, mdiPencil },
    }
  },
}
</script>
